/* eslint-disable react/no-unescaped-entities */
import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

function TermsConditions() {
  return (
    <>
      <Typography
        gutterBottom
        variant="h2"
        sx={{ justifyContent: "center", display: "flex" }}
      >
        {" "}
        Tyler Technologies, Inc.
        <br />
        Terms of Use
      </Typography>
      <Grid container spacing={2}>
        <Grid item>
          <Typography>AGREEMENT BETWEEN USER AND TYLER</Typography>
        </Grid>
        <Grid item>
          <Typography>
            This Web Site is comprised of various Web pages operated by Tyler
            Technologies, Inc. and its affiliates (“Tyler”). For the avoidance
            of doubt, NIC, Inc. and its affiliates are affiliates of Tyler.
          </Typography>
        </Grid>
        <Grid item>
          <Typography>
            This Web Site is offered to you conditioned on your acceptance
            without modification of the terms, conditions, and notices contained
            herein. Your use of this Web Site constitutes your agreement to all
            such terms, conditions, and notices.
          </Typography>
        </Grid>
        <Grid item>
          <Typography>
            THIS AGREEMENT CONTAINS A BINDING ARBITRATION PROVISION WHICH MAY BE
            ENFORCED BY THE PARTIES AND A WAIVER OF YOUR CLASS ACTION RIGHTS.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">
            Modification of These Terms of Use
          </Typography>
          <br />
          <Typography variant="body1">
            Tyler reserves the right to change the terms, conditions, and
            notices under which the tylertech.com Web Site is offered, including
            but not limited to the charges associated with the use of this Web
            Site.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Privacy Policy</Typography>
          <br />
          <Typography>
            User privacy is an important concern of Tyler. We are committed to
            privacy and security, and to providing the best possible user
            experience for our users and online customers. We also strive to
            protect the personal and confidential information of those who use
            our on-line Services. Click{" "}
            <a
              href="https://www.egov.com/privacy-policy/"
              target="_blank"
              rel="noreferrer"
            >
              here
            </a>{" "}
            to read our entire Privacy Policy, which is incorporated herein.
            This Privacy Policy may be updated by us from time to time, so
            please check here frequently.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Links to Third Party Sites</Typography>{" "}
          <br />
          <Typography>
            This Web Site may contain links to other Web Sites ("Linked Sites").
            The Linked Sites are not under the control of Tyler and Tyler is not
            responsible for the contents of any Linked Site, including without
            limitation any link contained in a Linked Site, or any changes or
            updates to a Linked Site. Tyler is not responsible for webcasting or
            any other form of transmission received from any Linked Site. Tyler
            is providing these links to you only as a convenience, and the
            inclusion of any link does not imply endorsement by Tyler of the
            site or any association with its operators.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">No Unlawful or Prohibited Use</Typography>{" "}
          <br />
          <Typography>
            As a condition of your use of this Web Site, you warrant to Tyler
            that you will not use this Web Site for any purpose that is unlawful
            or prohibited by these terms, conditions, and notices. You may not
            use this Web Site in any manner which could damage, disable,
            overburden, or impair this Web Site or interfere with any other
            party's use and enjoyment of this Web Site. You may not obtain or
            attempt to obtain any materials or information through any means not
            intentionally made available or provided for through the Web Sites.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Use of Communication Services</Typography>{" "}
          <br />
          <Typography>
            This Web Site may contain bulletin board services, chat areas, news
            groups, forums, communities, personal web pages, calendars, and/or
            other message or communication facilities designed to enable you to
            communicate with the public at large or with a group (collectively,
            "Communication Services"), you agree to use the Communication
            Services only to post, send and receive messages and material that
            are proper and related to the particular Communication Service. By
            way of example, and not as a limitation, you agree that when using a
            Communication Service, you will not:
          </Typography>
          <Grid>
            <ul>
              <li>
                Defame, abuse, harass, stalk, threaten or otherwise violate the
                legal rights (such as rights of privacy and publicity) of
                others.
              </li>
              <li>
                Publish, post, upload, distribute or disseminate any
                inappropriate, profane, defamatory, infringing, obscene,
                indecent or unlawful topic, name, material or information.
              </li>
              <li>
                Upload files that contain software or other material protected
                by intellectual property laws (or by rights of privacy of
                publicity) unless you own or control the rights thereto or have
                received all necessary consents.
              </li>
              <li>
                Upload files that contain viruses, corrupted files, or any other
                similar software or programs that may damage the operation of
                another's computer
              </li>
              <li>
                Advertise or offer to sell or buy any goods or services for any
                business purpose, unless such Communication Service specifically
                allows such messages.
              </li>
              <li>
                Conduct or forward surveys, contests, pyramid schemes or chain
                letters.
              </li>
              <li>
                Download any file posted by another user of a Communication
                Service that you know, or reasonably should know, cannot be
                legally distributed in such manner
              </li>
              <li>
                Falsify or delete any author attributions, legal or other proper
                notices or proprietary designations or labels of the origin or
                source of software or other material contained in a file that is
                uploaded.
              </li>
              <li>
                Restrict or inhibit any other user from using and enjoying the
                Communication Services.
              </li>
              <li>
                Violate any code of conduct or other guidelines which may be
                applicable for any particular Communication Service.
              </li>
              <li>
                Harvest or otherwise collect information about others, including
                e-mail addresses, without their consent.
              </li>
              <li>Violate any applicable laws or regulations.</li>
            </ul>
          </Grid>
          <Typography>
            <span>
              Tyler has no obligation to monitor the Communication Services.
              However, Tyler reserves the right to review materials posted to a
              Communication Service and to remove any materials in its sole
              discretion. Tyler reserves the right to terminate your access to
              any or all of the Communication Services at any time without
              notice for any reason whatsoever.
            </span>
          </Typography>
          <Typography>
            {" "}
            <span>
              Tyler reserves the right at all times to disclose any information
              as necessary to satisfy any applicable law, regulation, legal
              process or governmental request, or to edit, refuse to post or to
              remove any information or materials, in whole or in part, in
              Tyler's sole discretion.
            </span>
          </Typography>
          <Typography>
            {" "}
            <span>
              Always use caution when giving out any personally identifying
              information about yourself or your children in any Communication
              Service. Tyler does not control or endorse the content, messages
              or information found in any Communication Service and, therefore,
              Tyler specifically disclaims any liability with regard to the
              Communication Services and any actions resulting from your
              participation in any Communication Service. Managers and hosts are
              not authorized Tyler spokespersons, and their views do not
              necessarily reflect those of Tyler.
            </span>
          </Typography>
          <Typography>
            {" "}
            <span>
              Materials uploaded to a Communication Service may be subject to
              posted limitations on usage, reproduction and/or dissemination.
              You are responsible for adhering to such limitations if you
              download the materials.
            </span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">
            {" "}
            Materials Provided to Tyler or Posted at Any Tyler Web Site{" "}
          </Typography>{" "}
          <br />
          <Typography>
            <span>
              Tyler does not claim ownership of the materials you provide
              through or related to the Websites (including feedback and
              suggestions) or post, upload, input or submit to any Tyler Web
              Site or its associated services (collectively "Submissions").
              However, by posting, uploading, inputting, providing or submitting
              your Submission you are granting Tyler, its affiliated companies
              and necessary sublicensees permission to use your Submission in
              connection with the operation of their Internet businesses
              including, without limitation, the rights to: copy, distribute,
              transmit, publicly display, publicly perform, reproduce, edit,
              translate and reformat your Submission; and to publish your name
              in connection with your Submission.
            </span>
          </Typography>
          <Typography>
            <span>
              No compensation will be paid with respect to the use of your
              Submission, as provided herein. Tyler is under no obligation to
              post or use any Submission you may provide and may remove any
              Submission at any time in Tyler's sole discretion.
            </span>
          </Typography>
          <Typography>
            {" "}
            <span>
              By posting, uploading, inputting, providing or submitting your
              Submission you warrant and represent that you own or otherwise
              control all of the rights to your Submission as described in this
              section including, without limitation, all the rights necessary
              for you to provide, post, upload, input or submit the Submissions.
            </span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Liability Disclaimer</Typography> <br />
          <Typography>
            <span>
              THE INFORMATION, SOFTWARE, PRODUCTS, AND SERVICES INCLUDED IN OR
              AVAILABLE THROUGH THIS WEB SITE MAY INCLUDE INACCURACIES OR
              TYPOGRAPHICAL ERRORS. CHANGES ARE PERIODICALLY ADDED TO THE
              INFORMATION HEREIN. TYLER AND/OR ITS SUPPLIERS MAY MAKE
              IMPROVEMENTS AND/OR CHANGES IN THIS WEB SITE AT ANY TIME. ADVICE
              RECEIVED VIA THIS WEB SITE SHOULD NOT BE RELIED UPON FOR PERSONAL,
              MEDICAL, LEGAL OR FINANCIAL DECISIONS AND YOU SHOULD CONSULT AN
              APPROPRIATE PROFESSIONAL FOR SPECIFIC ADVICE TAILORED TO YOUR
              SITUATION.
            </span>
          </Typography>
          <Typography>
            <span>
              TYLER AND/OR ITS SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE
              SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND ACCURACY
              OF THE INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED
              GRAPHICS CONTAINED ON THIS WEB SITE FOR ANY PURPOSE. TO THE
              MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, ALL SUCH INFORMATION,
              SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS ARE PROVIDED "AS
              IS" WITHOUT WARRANTY OR CONDITION OF ANY KIND. TYLER AND/OR ITS
              SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS WITH
              REGARD TO THIS INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND
              RELATED GRAPHICS, INCLUDING ALL IMPLIED WARRANTIES OR CONDITIONS
              OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, TITLE AND
              NON-INFRINGEMENT.
            </span>
          </Typography>
          <Typography>
            <span>
              TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO EVENT
              SHALL TYLER AND/OR ITS SUPPLIERS BE LIABLE FOR ANY DIRECT,
              INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL DAMAGES OR
              ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT LIMITATION, DAMAGES FOR
              LOSS OF USE, DATA OR PROFITS, ARISING OUT OF OR IN ANY WAY
              CONNECTED WITH THE USE OR PERFORMANCE OF THIS WEB SITE, WITH THE
              DELAY OR INABILITY TO USE THIS WEB SITE OR RELATED SERVICES, THE
              PROVISION OF OR FAILURE TO PROVIDE SERVICES, OR FOR ANY
              INFORMATION, SOFTWARE, PRODUCTS, SERVICES AND RELATED GRAPHICS
              OBTAINED THROUGH THIS WEB SITE, OR OTHERWISE ARISING OUT OF THE
              USE OF THIS WEB SITE, WHETHER BASED ON CONTRACT, TORT, NEGLIGENCE,
              STRICT LIABILITY OR OTHERWISE, EVEN IF TYLER OR ANY OF ITS
              SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES. BECAUSE
              SOME STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION OR LIMITATION
              OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL DAMAGES, THE ABOVE
              LIMITATION MAY NOT APPLY TO YOU. IF YOU ARE DISSATISFIED WITH ANY
              PORTION OF THIS WEB SITE, OR WITH ANY OF THESE TERMS OF USE, YOUR
              SOLE AND EXCLUSIVE REMEDY IS TO DISCONTINUE USING THIS WEB SITE.
            </span>
          </Typography>{" "}
          <br />
          <Typography>
            SERVICE CONTACT:{" "}
            <a href="mailto:webadmin@tylertech.com">webadmin@tylertech.com</a>
          </Typography>{" "}
          <br /> <br />
          <Typography variant="h2">
            {" "}
            Termination/Access Restriction{" "}
          </Typography>{" "}
          <br />
          <Typography>
            Tyler reserves the right, in its sole discretion, to terminate your
            access to this Web Site and the related services or any portion
            thereof at any time, without notice.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Disputes</Typography> <br />
          <Typography>
            <span>
              Please contact Tyler at 5101 Tennyson Pkwy, Plano, Texas 75024,
              Attn: Legal Department, regarding any claim or controversy arising
              out of or relating to this agreement, or any breach thereof, and
              Tyler will attempt in good faith to resolve the claim, or we can
              agree to engage in mediation. Each party agrees to pay for its own
              expenses in engaging in mediation. Any claim, dispute, or
              controversy that cannot be resolved through mediation within
              thirty (30) days will be settled by arbitration as set forth
              below.
            </span>
          </Typography>
          <Typography>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;A. Arbitration. Except for claims or
              controversies for which Tyler may pursue injunctive relief, any
              claim, dispute, or controversy arising out of or relating to this
              Web Site, this agreement, or the breach, termination, enforcement,
              interpretation, or validity of this agreement, will be resolved
              exclusively by binding arbitration administered by the American
              Arbitration Association (“AAA”) before a single arbitrator.
              Payment of all filing, administration, and arbitrator fees will be
              governed by AAA’s applicable rules. The arbitrator’s decision
              shall be controlled by this agreement and any other agreements
              referenced herein. If the claim or controversy is for $10,000 or
              less, Tyler agrees that you may choose whether the arbitration
              will be conducted solely on the basis of documents submitted to
              the arbitrator through a telephonic hearing or by an in-person
              hearing as established by the AAA Rules. If the claim or
              controversy exceeds $10,000, the right to a hearing will be
              determined by the AAA Rules. Regardless of the manner in which the
              arbitration is conducted, the award of the arbitrator shall be
              accompanied by a statement of the reasons upon which the award is
              based. You understand that, in the absence of this provision, you
              would have had a right to litigate disputes through a court,
              including the right to litigate claims on a class-wide or
              class-action basis, and that you have expressly and knowingly
              waived those rights and agreed to resolve any disputes through
              binding arbitration in accordance with the provisions of this
              paragraph.
            </span>
          </Typography>
          <br />
          <Typography>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;B. Limitation on Time to File. YOU AGREE
              THAT IF YOU DO NOT FILE A DEMAND TO ARBITRATE A DISPUTE WITHIN ONE
              (1) YEAR AFTER THE DISPUTE ARISES, SUCH CAUSE OF ACTION OR CLAIM
              IS PERMANENTLY BARRED
            </span>
          </Typography>
          <br />
          <Typography>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;C.Arbitration on an Individual Basis Only;
              Class Arbitration Waiver. YOU AGREE THAT, BY ACCEPTING THIS
              AGREEMENT, YOU AND TYLER ARE EACH WAIVING THE RIGHT TO PARTICIPATE
              IN OR BRING A CLASS ACTION. TYLER AND YOU AGREE TO ARBITRATE
              SOLELY ON AN INDIVIDUAL BASIS AND AGREE THAT THIS AGREEMENT DOES
              NOT PERMIT CLASS ARBITRATION OR ANY CLAIMS BROUGHT AS A PLAINTIFF
              OR CLASS MEMBER IN ANY CLASS OR REPRESENTATIVE ARBITRATION
              PROCEEDING. THE ARBITRATOR MAY NOT CONSOLIDATE MORE THAN ONE
              PERSON’S CLAIMS, AND MAY NOT OTHERWISE PRESIDE OVER ANY FORM OF A
              REPRESENTATIVE OR CLASS PROCEEDING. THIS AGREEMENT EVIDENCES A
              TRANSACTION IN INTERSTATE COMMERCE, AND THUS THE FEDERAL
              ARBITRATION ACT (“FAA”) GOVERNS THE INTERPRETATION AND ENFORCEMENT
              OF THIS PROVISION. IF FOR ANY REASON, A CLAIM PROCEEDS IN COURT
              RATHER THAN ARBITRATION, TYLER AND YOU WAIVE ANY RIGHT TO A JURY
              TRIAL OR TO PARTICIPATE IN A CLASS ACTION AGAINST EACH OTHER.
            </span>
          </Typography>
          <br />
          <Typography>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;D. Applicable Law and Venue. Although this
              Web Site is accessible over the Internet and therefore available
              worldwide, this Web Site and its content are intended for
              residents of the United States only. If you choose to access this
              Web Site from locations outside the United States, such conduct is
              at your own risk and subject to the laws of the United States of
              America, which may differ from privacy laws in your state or home
              country, and you are responsible for compliance with any local
              laws and regulations. Nothing in this Web Site should be
              interpreted as a promotion or solicitation for any product of any
              nature that is not authorized by the laws and regulations of the
              country where you are located. You agree that the laws of the
              State of Texas, without giving effect to any principles of
              conflicts of law, govern this agreement and any dispute of any
              sort that may arise between you and us or any of our affiliates.
              Any arbitration related to this agreement shall occur in Collin
              County, Texas. Tyler and you acknowledge that this agreement
              evidences a transaction involving interstate commerce.
              Notwithstanding the foregoing paragraph with respect to applicable
              substantive law, any arbitration conducted pursuant to this
              agreement shall be governed by the FAA, 9 U.S.C. §§ 1-16.
            </span>
          </Typography>
          <br />
          <Typography>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;E. Conflict. If any part of this
              arbitration provision is deemed to be invalid, unenforceable or
              illegal, or otherwise conflicts with the code of procedure
              established by the AAA, the balance of this arbitration provision
              shall remain in effect and shall be construed in accordance with
              its terms as if the invalid, unenforceable, illegal, or
              conflicting provision were not contained herein.
            </span>
          </Typography>
          <br />
          <Typography>
            <span>
              &nbsp;&nbsp;&nbsp;&nbsp;F. Injunctive Relief. Notwithstanding
              anything to the contrary, Tyler retains the right to seek
              injunctive relief if you use this Web Site in violation of the
              access rights or the restrictions on use, infringe upon or
              misappropriate Tyler’s intellectual property rights, or breach
              your obligation to maintain the confidentiality of Tyler’s
              confidential or proprietary information made available to you
              through this Web Site.
            </span>
          </Typography>
        </Grid>

        <Grid item>
          <Typography variant="h2">Miscellaneous</Typography> <br />
          <Typography>
            <span>
              You agree that no joint venture, partnership, employment, or
              agency relationship exists between you and Tyler as a result of
              this agreement or use of this Web Site. Tyler's performance of
              this agreement is subject to existing laws and legal process, and
              nothing contained in this agreement is in derogation of Tyler's
              right to comply with governmental, court and law enforcement
              requests or requirements relating to your use of this Web Site or
              information provided to or gathered by Tyler with respect to such
              use. If any part of this agreement is determined to be invalid or
              unenforceable pursuant to applicable law including, but not
              limited to, the warranty disclaimers and liability limitations set
              forth above, then the invalid or unenforceable provision will be
              deemed superseded by a valid, enforceable provision that most
              closely matches the intent of the original provision and the
              remainder of the agreement shall continue in effect. Unless
              otherwise specified herein, this agreement constitutes the entire
              agreement between the user and Tyler with respect to this Web Site
              and it supersedes all prior or contemporaneous communications and
              proposals, whether electronic, oral or written, between the user
              and Tyler with respect to this Web Site. A printed version of this
              agreement and of any notice given in electronic form shall be
              admissible in judicial or administrative proceedings based upon or
              relating to this agreement to the same extent and subject to the
              same conditions as other business documents and records originally
              generated and maintained in printed form. It is the express wish
              to the parties that this agreement and all related documents be
              drawn up in English.
            </span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Copyright and Trademark Notices </Typography>{" "}
          <br />
          <Typography>
            All contents of this Web Site are: ©2019 Tyler Technologies, Inc. or
            ©2020 NIC Inc. All rights reserved.
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">Trademarks</Typography> <br />
          <Typography>
            The names of actual companies and products mentioned herein may be
            the trademarks of their respective owners.
          </Typography>
          <Typography>
            <span>
              The example companies, organizations, products, people and events
              depicted herein are fictitious. No association with any real
              company, organization, product, person, or event is intended or
              should be inferred.
            </span>
          </Typography>
          <Typography>
            <span>Any rights not expressly granted herein are reserved.</span>
          </Typography>
        </Grid>
        <Grid item>
          <Typography variant="h2">
            Notices and Procedure for Making Claims of Copyright Infringement{" "}
          </Typography>{" "}
          <br />
          <Typography>
            If you believe that this Web Site or its related services contain
            elements that infringe your copyrights, please provide Tyler’s
            designated copyright agent with the following information in
            writing:
          </Typography>
          <Grid>
            <ul>
              <li>
                A physical or electronic signature of person authorized to act
                on behalf of the owner of an exclusive right that is allegedly
                infringed;
              </li>
              <li>
                Identification of the copyrighted work claimed to have been
                infringed, or multiple copyrighted works at a single online site
                are covered by a single notification, a representative list of
                such works at that site
              </li>
              <li>
                Identification of the material that is claimed to be infringing
                or to be the subject of infringing activity and that is to be
                removed or access to which is to be disabled, and information
                reasonably sufficient to permit the service provider to locate
                the material;
              </li>
              <li>
                Information reasonably sufficient to permit the service provider
                to contact the complaining party, such as an address, telephone
                number, and if available, an electronic mail address at which
                the complaining party may be contacted;
              </li>
              <li>
                A statement that the complaining party has a good faith belief
                that use of the material in the manner complained of is not
                authorized by the copyright owner, its agent, or the law; and
              </li>
              <li>
                {" "}
                A statement that the information in the notification is
                accurate, and under penalty of perjury, that the complaining
                party is authorized to act on behalf of the owner of an
                exclusive right that is allegedly infringed.
              </li>
            </ul>
          </Grid>
          <Typography> By mail:</Typography> <br />
          <Typography>
            Tyler DMCA Agent
            <br />
            c/o Stinson LLC
            <br />
            Stinson IP Administrator
            <br />
            1201 Walnut
            <br />
            Suite 2900
            <br />
            Kansas City, MO 64106
          </Typography>
          <br />
          <Typography>
            Attention: Tyler Designated Copyright Agent
          </Typography>{" "}
          <br />
          <br />
          <Typography>
            By phone: (816) 842-8600
            <br />
            By fax: (816) 691-3495
            <br />
            By email: <a href="mailto:DMCA@stinson.com">DMCA@stinson.com</a>
          </Typography>
          <br />
          <Typography>
            For additional information regarding this procedure, please
            reference 17 U.S.C. § 512.
          </Typography>
        </Grid>
      </Grid>
    </>
  );
}

export default TermsConditions;
